import React from "react";
import Header from "../../commons/Header";
import Footer from "../../commons/Footer";
import Content from "./Content";
import ProvideUserInfo from "../../providers/ProvideUserInfo";
import ProvideAffiliatorMyInfo from "../../providers/ProvideAffiliatorMyInfo";
import ProvideModal from "../../providers/ProvideModal";
import ProvideBalanceLog from "./ProvideBalanceLog";
import ProvidePopupable from "../../providers/ProvidePopupable";
import { LoggedInUserContext } from "../../providers/ProvideLoggedInUser";

const InnerComponent = () => {
  const { signedIn } = React.use(LoggedInUserContext);

  React.useEffect(() => {
    if (!signedIn) {
      // Get locale from current URL or default to 'id'
      const urlParams = new URLSearchParams(window.location.search);
      const locale = urlParams.get("locale") || "id";
      
      // Build redirect URL with query parameters
      const redirectUrl = `/?locale=${locale}&login_popup_auto_shown=1&redirect_after_login=%2Fusers%2Faffiliators`;
      
      // Redirect to login page
      window.location.href = redirectUrl;
    }
  }, [signedIn]);

  // Don't render content if user is not signed in (will redirect)
  if (!signedIn) {
    return null;
  }

  return (
    <React.Fragment>
      <Header />
      <Content />
      <Footer />
    </React.Fragment>
  );
};

const UnnamedComponent = (props) => {
  let ret = (
    <InnerComponent />
  );
  ret = <ProvideUserInfo>{ret}</ProvideUserInfo>;
  ret = <ProvideAffiliatorMyInfo>{ret}</ProvideAffiliatorMyInfo>;
  ret = <ProvideModal>{ret}</ProvideModal>;
  ret = <ProvideBalanceLog>{ret}</ProvideBalanceLog>;
  ret = <ProvidePopupable>{ret}</ProvidePopupable>;
  return ret;
};

export default UnnamedComponent;